<template>
  <div id="contents">
    <div id="payment" class="container">
      <!-- <button @click="calcPriceList">테스트버튼</button> -->
      <template v-if="mode === 'pledge' || mode === 'pledgeCmpl'">
        <h3 class="stitle">확약</h3>
        <pledge-procedure v-if="mode === 'pledge'" />
      </template>
      <template v-else>
        <h3 class="stitle">결제</h3>
        <p class="mb50">좌석은 결제 완료 시 확정되며, 결제 완료 전 다른 사용자가 예매시 좌석이 매진될 수 있습니다.</p>
      </template>
      <ul class="basketList">
        <li v-for="(booking, i) in bookingList" :key="i">
          <dl>
            <dt class="stitle2">{{ booking.mrktnPdNm }}</dt>
            <dd class="colorBox">
              <ul class="listBox">
                <li>
                  <strong>날짜</strong>
                  <span>{{ booking.expVisitRvdt }}</span>
                </li>
                <li>
                  <strong>회차</strong>
                  <span>{{ booking.mrktnScheSeqNm }}({{ booking.scheTime }})</span>
                </li>
                <li class="wdful">
                  <strong>인원</strong>
                  <span>
                    <i>체험자 {{ showPcnt(booking.includeList) }}명</i>
                    <i v-if="booking.leaderList.length > 0">인솔자 {{ booking.leaderList.length }}명</i>
                  </span>
                </li>
                <li v-if="groupPersDiv === '01' && booking.multiDiscountYn">
                  <div class="multiDiscount_box">
                    <span class="checkbox">
                      <input type="checkbox" :id="'md_' + i" name="multiDiscountYn" v-model="booking.multiDiscountYn" true-value="Y" false-value="N" />
                      <label :for="'md_' + i" style="font-weight: 500" class="sameExpr">
                        다중 회차 할인 적용
                        <i>(동일한 체험자가 여러 회차 이용시)</i>
                      </label>
                    </span>
                    <span class="multiDiscount_detail" @click="openModal">[상세정보]</span>
                  </div>
                </li>
              </ul>
              <div class="product_price">
                <span v-if="booking.originPrice !== booking.saleAmt">{{ _wonFormat(booking.originPrice, '무료') }}</span>
                <br />
                <strong>{{ _wonFormat(booking.saleAmt, '무료') }}</strong>
              </div>
            </dd>
          </dl>
        </li>
      </ul>
      <ul class="priceBox mb50">
        <li>
          <span>총 상품 금액</span>
          <strong>
            <i>{{ _wonFormat(totOriginPrice, '무료') }}</i>
          </strong>
        </li>
        <li>
          <span>총 할인 금액</span>
          <strong>
            <i>{{ _priceFormat(totDcPrice) }}</i>
            원
          </strong>
        </li>
        <li class="totalPrice">
          <span>총 결제 금액</span>
          <strong>
            <i>{{ _wonFormat(totSaleAmt, '무료') }}</i>
          </strong>
        </li>
      </ul>
      <dl v-if="mode === 'normal'" class="payWay mb50">
        <dt class="stitle1 tleft mb10">결제수단</dt>
        <dd>
          <ul class="radiobox">
            <li>
              <input type="radio" name="payWaySel" id="pwCard" value="02" v-model="paymentType.payMethod" />
              <label for="pwCard"><span>카드결제 및 간편결제</span></label>
            </li>
            <li>
              <input type="radio" name="payWaySel" id="pwTossPay" value="TOSSPAY" v-model="paymentType.payMethod" />
              <label for="pwTossPay" class="tosspay_method">
                <span>토스페이</span>
                <span v-if="isTosspayDeadline" class="tosspay_benefit">혜택</span>
                <span v-if="isTosspayDeadline" class="tosspay_notice">
                  <a
                    href="https://www.koreajobworld.or.kr/boardView.do?bid=1&mid=42&idx=55360&rnum=578&pageNo=1&site=10&portalMenuNo=39&searchField=0"
                    target="_blank"
                  >
                    <span>유의사항</span>
                    <img src="@/assets/images/tosspay_link.png" alt="tosspay link icon" class="toss_icon" />
                  </a>
                </span>
              </label>
              <div v-if="isTosspayDeadline" class="payToss_list ml10">
                <div v-if="isBenefitStartTxt" class="tosspay_sub">
                  <span>※ 할인 및 적립 혜택은 7/15(수) 결제 건부터 적용됩니다.</span>
                </div>
                <div v-if="isBebefitFirstEndTxt" class="tosspay_sub">
                  <span>※ 할인 및 적립 혜택은 10/14(수) 결제 건까지 적용됩니다.</span>
                </div>
                <div v-if="isBebefitSecondEndTxt" class="tosspay_sub">
                  <span>※ 할인 및 적립 혜택은 3/9(화) 결제 건까지 적용됩니다.</span>
                </div>
                <div v-if="isBebefitDiscount" class="tosspay_sub">
                  <img src="@/assets/images/tosspay_percent.png" alt="otsspay percent icon" class="toss_icon" />
                  <span>계좌/머니 결제 시 2% 즉시 할인(최대 1만원)(카드 제외)</span>
                </div>
                <div v-if="isBebefitFirstPay" class="tosspay_sub">
                  <img src="@/assets/images/tosspay_point.png" alt="tosspay point icon" class="toss_icon" />
                  <span>생애 첫 결제 시 토스포인트 3,000P 즉시 적립</span>
                </div>
              </div>
            </li>
            <!-- 간편결제 오픈시 제외 -->
            <li v-if="false">
              <input type="radio" name="payWaySel" id="pwEasy" value="간편결제" v-model="paymentType.payMethod" />
              <label for="pwEasy"><span>간편 결제</span></label>
              <div class="pwEasy_list mt10">
                <a class="sel_toss" :class="{ selected: checkEasyPaySelected('TOSSPAY') }" @click="() => onEasyPayClick('TOSSPAY')">
                  <span>토스페이</span>
                </a>
                <a class="sel_naver" :class="{ selected: checkEasyPaySelected('NAVERPAY') }" @click="() => onEasyPayClick('NAVERPAY')">
                  <span>네이버페이</span>
                </a>
                <a class="sel_kakao" :class="{ selected: checkEasyPaySelected('KAKAOPAY') }" @click="() => onEasyPayClick('KAKAOPAY')">
                  <span>카카오페이</span>
                </a>
              </div>
              <div class="pwEasy_list mt10">
                <a class="" :class="{ selected: checkEasyPaySelected('SAMSUNGPAY') }" @click="() => onEasyPayClick('SAMSUNGPAY')">
                  <span>삼성페이</span>
                </a>
                <a class="" :class="{ selected: checkEasyPaySelected('LPAY') }" @click="() => onEasyPayClick('LPAY')">
                  <span>엘페이</span>
                </a>
                <a class="" :class="{ selected: checkEasyPaySelected('PAYCO') }" @click="() => onEasyPayClick('PAYCO')">
                  <span>페이코</span>
                </a>
              </div>
            </li>
            <li v-if="ctAble && !isCardOnlyProduct">
              <input type="radio" name="payWaySel" id="pwbankbook" value="03" v-model="paymentType.payMethod" />
              <label for="pwbankbook"><span>계좌 이체</span></label>
            </li>
            <li v-if="nobankAble && !isCardOnlyProduct">
              <input type="radio" name="payWaySel" id="pwNobankbook" value="04" v-model="paymentType.payMethod" />
              <label for="pwNobankbook"><span>무통장 입금</span></label>
            </li>
            <li v-if="purmeeAble && !isCardOnlyProduct">
              <input type="radio" name="payWaySel" id="purmee" value="09" v-model="paymentType.payMethod" />
              <label for="purmee"><span>체험카드</span></label>
            </li>
            <div v-if="paymentType.payMethod === '09'" class="purmee">
              <div class="colorBox">
                <span class="pb_txt">
                  1. 청소년 체험지원카드는 지방자치단체의 지원을 받는 포인트로 결제시 현금영수증 발급이 안됩니다.
                  <br />
                  - 현재 사용가능한 지방자치단체: 강서구, 도봉구, 동작구, 성동구, 성북구, 여수시, 세종시
                  <br />
                  2. 포인트 잔액 조회 후 결제를 진행하여 주시기 바랍니다.
                  <br />
                  3. 예약한 내용을 변경하고자 하는 경우에는 취소 후 다시 예약하시기 바랍니다.
                  <br />
                  예약을 취소할 경우 한국잡월드의 환불규정에 따라 포인트가 전액 환급되지 않을 수 있습니다.
                  <br />
                  4. 지방자치단체가 정한 포인트 사용 마감일(매년 12월 중순경) 이후에는 예약분을 취소하더라도 포인트 환급이 불가능합니다.
                  <br />
                </span>
              </div>
              <span class="pb_txt">
                <font color="red">※잔액조회 후 결제를 진행해주세요.</font>
              </span>
              <div>
                <div>
                  <dl class="prumee-input">
                    <dd>
                      <span class="p-label">카드번호 :</span>
                      <input type="text" v-model="purmee.purmeeCardNo" size="16" />
                    </dd>
                    <dd>
                      <span class="p-label">카드ID :</span>
                      <input type="text" v-model="purmee.purmeeId" size="15" />
                      <button @click="onPurmeeBalanceClick()">조회</button>
                    </dd>
                    <dd>
                      <span class="p-label">잔액 :</span>
                      <input type="text" v-model="purmee.purmeeBalance" size="15" readonly="readonly" />
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <!-- <li>
              <input type="radio" name="payWaySel" id="pwPhone" value="휴대폰" v-model="paymentType.payMethod" />
              <label for="pwPhone"><span>휴대폰 결제</span></label>
            </li>
            <li>
              <input type="radio" name="payWaySel" id="pwGiftcard" value="문화상품권" v-model="paymentType.payMethod" />
              <label for="pwGiftcard"><span>문화상품권</span></label>
            </li> -->
          </ul>
        </dd>
      </dl>
      <div class="mb50">
        <p><reserve-info-agree-popup v-model="reserveInfoAgree" /></p>
        <p><ReservePolicyAgreePopup v-model="reservePolicyAgree" /></p>
      </div>

      <div class="btn_wrap">
        <a v-if="pledegeOnly()" class="btn btn_bg line" @click="onMoreItem">
          <span>추가예약</span>
        </a>
        <a v-if="paymentType.payMethod != '09'" class="btn btn_bg color" @click="onPaymentClick">
          <span v-if="mode === 'normal'">결제하기</span>
          <span v-else>예약완료</span>
        </a>
      </div>
    </div>

    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" title="다중 회차 할인">
      <!-- default 슬롯 콘텐츠 -->
      <div>
        <p class="colorbox mb20">
          한국잡월드 어린이체험관, 청소년체험관은
          <b>동일한 체험자가 다중 회차 예약 시</b>
          입장료 할인이 가능합니다.
        </p>
        <h5 class="stitle2 mb10">어린이체험관</h5>
        <div class="tb_wrap mb10">
          <table class="tb_basic multiDiscount_table">
            <caption>다중 회차 할인</caption>
            <colgroup>
              <col width="20%" />
              <col width="40%" />
              <col />
            </colgroup>
            <thead>
              <tr class="tbg">
                <th scope="col">구분</th>
                <th scope="col">1회차 이용 시</th>
                <th scope="col">당일 1회차 추가 이용시</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>이용요금</td>
                <td>18,000원</td>
                <td>15,000원</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h5 class="stitle2 mb10">청소년체험관</h5>
        <div class="tb_wrap mb10">
          <table class="tb_basic multiDiscount_table">
            <caption>다중 회차 할인</caption>
            <colgroup>
              <col width="20%" />
              <col width="40%" />
              <col />
            </colgroup>
            <thead>
              <tr class="tbg">
                <th scope="col">구분</th>
                <th scope="col">1회차 이용 시</th>
                <th scope="col">당일 1개 체험실 추가 이용시</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>이용요금</td>
                <td>9,000원</td>
                <td>6,000원</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="mb20">※ 다중 회차 할인을 선택하면 입장료 할인이 적용 됩니다.</p>
      </div>
      <!-- /default -->
      <!-- footer 슬롯 콘텐츠 -->
      <template slot="footer">
        <div class="btn_wrap tcen">
          <a class="wdhalf btn btn_bg gray" @click="closeModal">닫기</a>
          <a class="wdhalf btn btn_bg color" @click="chkAllModal">다중할인 일괄 적용</a>
        </div>
      </template>
      <!-- /footer -->
    </modal>

    <div v-if="iosPopMsg">
      <p class="ios-msg">
        결제창이 뜨지 않을 경우,
        <span class="strong" @click="onRefershClick">[새로고침]</span>
        후 다시 시도해 주세요.
      </p>
    </div>
  </div>
</template>

<script>
import { getPaymentInfo, calculatePrice, getLgupayInfo, postOrder, postOrderPrumee } from '@/api/api_reserve';
import { groupBy } from 'lodash';
import { orderValid, orderPledge } from '@/utils/reserve';
import lguPaymentLaunch from '@/utils/lguUtil';
import { mapActions, mapGetters, mapState } from 'vuex';
import PledgeProcedure from '@/components/payment/PledgeProcedure';
import ReserveInfoAgreePopup from '@/components/popup/ReserveInfoAgreePopup.vue';
import ReservePolicyAgreePopup from '@/components/popup/ReservePolicyAgreePopup.vue';
import Modal from '@/components/common/Modal.vue';

//NH카드 결제 상품
const CARD_ONLY_PRODUCTS = [100098, 100099];

export default {
  components: { Modal, PledgeProcedure, ReserveInfoAgreePopup, ReservePolicyAgreePopup },
  props: {},
  data() {
    return {
      reserveInfoAgree: false,
      reservePolicyAgree: false,
      bundleRvNo: '',
      totOriginPrice: 0,
      totDcPrice: 0,
      totSaleAmt: 0,
      tossPayments: null,
      paymentType: {
        payMethod: '02',
        easyPay: 'TOSSPAY',
      },
      ctAble: false,
      nobankAble: false,
      dupleRequest: false,
      purmee: {
        purmeeId: '',
        purmeeCardNo: '',
        purmeeBalance: '',
      },
      paymentClickCnt: 0,
      multiDiscountNotice: true,
      modal: {
        open: false,
      },
    };
  },
  computed: {
    ...mapState({
      mode: (state) => state.payment.mode,
    }),
    ...mapGetters(['bookingList']),
    //watch용 변수
    multiDiscountYns() {
      return this.bookingList.map((e) => e.multiDiscountYn);
    },
    purmeeAble() {
      return this.bookingList.every((e) => e.pdDiv === '02') && this.groupPersDiv === '02';
    },
    iosPopMsg() {
      return this.isMobileSafari && this.paymentClickCnt > 0;
    },
    //NH카드 결제 상품
    isCardOnlyProduct() {
      const mrktnPdNo = this.bookingList?.[0]?.mrktnPdNo;
      //console.log(mrktnPdNo);
      //console.log(typeof mrktnPdNo); 정수형
      return CARD_ONLY_PRODUCTS.includes(mrktnPdNo);
    },
    // tosspay 결제혜택 시작일 안내 노출
    isBenefitStartTxt() {
      const expireDate = new Date(2026, 6, 15, 0, 0, 0); // 2026년 7월 15일 00시
      const today = new Date();

      return today < expireDate;
    },
    // tosspay 결제혜택 할인 2% 26.7.15~26.10.14,26.12.10~27.1.14
    isBebefitDiscount() {
      const today = new Date();

      // 구간 1: 2026년 7월 15일 00시 ~ 2026년 10월 14일 23시 59분
      const start1 = new Date(2026, 6, 14, 0, 0, 0);
      const end1 = new Date(2026, 9, 14, 23, 59, 59);

      // 구간 2: 2026년 12월 10일 00시 ~ 2027년 3월 9일 23시 59분
      const start2 = new Date(2026, 11, 10, 0, 0, 0);
      const end2 = new Date(2027, 2, 9, 23, 59, 59);

      // 구간 1 또는 구간 2에 포함되는지 확인
      const inRange1 = today >= start1 && today <= end1;
      const inRange2 = today >= start2 && today <= end2;

      return inRange1 || inRange2;
    },
    // tosspay 결제혜택 첫결제 3000p 26.7.15~27.1.14
    isBebefitFirstPay() {
      const startDate = new Date(2026, 6, 14, 0, 0, 0); // 2026년 7월 15일 00시
      const endDate = new Date(2027, 0, 14, 0, 0, 0); // 2027년 1월 14일 00시
      const today = new Date();

      // 시작 시간을 지났고, 종료 시간보다는 전일 때만 true
      return today >= startDate && today <= endDate;
    },
    // tosspay 결제혜택 종료 안내 노출 1차
    isBebefitFirstEndTxt() {
      const expireDate = new Date(2026, 9, 14, 0, 0, 0); // 2026년 10월 14일 00시
      const today = new Date();

      return today == expireDate;
    },
    // tosspay 결제혜택 종료 안내 노출 2차
    isBebefitSecondEndTxt() {
      const expireDate = new Date(2027, 2, 9, 0, 0, 0); // 2027년 3월 9일 00시
      const today = new Date();

      return today == expireDate;
    },
    // tosspay 결제혜택 해제 26.7.15~27.3.9
    isTosspayDeadline() {
      const startDate = new Date(2026, 6, 14, 0, 0, 0); // 2026년 7월 15일 00시
      const endDate = new Date(2027, 2, 9, 0, 0, 0); // 2027년 3월 9일 00시
      const today = new Date();

      return today >= startDate && today <= endDate;
    },
  },
  watch: {
    multiDiscountYns() {
      this.calcPriceList();
    },
  },
  created() {
    //this.bundleRvNo = parseInt(this.$route.params.id);
    this.initialLoad();
  },
  mounted() {
    this.calcPriceList();
  },
  destroyed() {
    this.clearPayment();
    try {
      if (window.closeIframe) {
        closeIframe();
      }
      if (window.PAYMENT && window.PAYMENT.close) {
        window.PAYMENT.close();
      }
      if (window.event_msg) {
        window.event_msg = undefined;
      }
      if (window.event_msg2) {
        window.event_msg2 = undefined;
      }
    } catch (e) {
      //iframe 닫기 관련 에러,
    }
  },
  methods: {
    ...mapActions(['updateBookingPrice', 'removeCartItem', 'clearPayment', 'addCartItem']),
    async initialLoad() {
      const expVisitRvdt = this.bookingList?.[0].expVisitRvdt;
      getPaymentInfo(expVisitRvdt).then((e) => {
        if (e.success) {
          this.nobankAble = e.response.nobankDpsBdtDt?.nobankPossYn === 'Y';
          this.ctAble = e.response.nobankDpsBdtDt?.ctPossYn === 'Y';
        }
      });

      const host = window.location.host;
      //if (host === 'www.koreajobworld.or.kr') {
      //await this.$loadScript('https://xpay.uplus.co.kr/xpay/js/xpay_crossplatform.js'); //잡월드 기존
      await this.$loadScript('https://xpayvvip.tosspayments.com/xpay/js/xpay_crossplatform.js'); //service
      //} else {
      //  await this.$loadScript('https://pretest.tosspayments.com:9443/xpay/js/xpay_crossplatform.js'); //test
      //}
      await this.$loadScript('https://api.purmee.kr/static/js/client.js').then((e) => {
        e.classList.add('payform'); //class="payform" 고정 값입니다.
      });
    },
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },
    chkAllModal() {
      this.bookingList.forEach((e) => {
        if (e.multiDiscountYn === 'N') e.multiDiscountYn = 'Y';
        this.closeModal();
        document.querySelector('.btn_wrap').scrollIntoView(true);
      });
    },
    pledegeOnly() {
      // 마케팅 상품 제외
      const mrktnPdChk = this.bookingList.some((item) => item.mrktnPdYn === 'Y');
      // 결제 모드 확인
      const chkMode = this.mode === 'pledge';
      // 확약서 전용 상품 확인
      const onlyPledegeList = ['724', '898', '916']; // 확약서예약 만 사용할 상품번호 추가
      const chkPledege = onlyPledegeList.every((item) => {
        return this.bookingList.find((e) => e.mrktnPdNo.toString() === item);
      });
      return !chkPledege && chkMode && !mrktnPdChk;
    },
    async calcPriceList() {
      const data = await calculatePrice({ bookingList: this.bookingList, groupPersDiv: this.groupPersDiv });
      if (data.success) {
        const orderPrice = data.response.orderPrice;
        this.totDcPrice = orderPrice.totDcPrice;
        this.totOriginPrice = orderPrice.totOriginPrice;
        this.totSaleAmt = orderPrice.totSaleAmt;
        this.updateBookingPrice(orderPrice.priceList);
      }
    },
    async normalPayment() {
      const paymentInfo = {
        payMethod: this.paymentType.payMethod,
        easyPay: '',
      };
      // if (paymentInfo.payMethod === '간편결제') {
      //   paymentInfo.payMethod = '02';
      //   paymentInfo.easyPay = this.paymentType.easyPay;
      // }
      if (paymentInfo.payMethod === 'TOSSPAY') {
        paymentInfo.payMethod = '02';
        paymentInfo.easyPay = this.paymentType.easyPay;
      }
      try {
        const data = await getLgupayInfo({
          ...paymentInfo,
          bookingList: this.bookingList,
          groupPersDiv: this.groupPersDiv,
          completeUrl: '/' + this.currentRouteType + '/reserve/paymentCmpl/',
        });
        if (data.success) {
          if (data.response.amount > 0) {
            const payReq = data.response.payReq;
            this.paymentClickCnt += 1;
            lguPaymentLaunch(payReq, this.paymentSuccess);

            // 결제 수단 파라미터
            // const payment = data.response.payment;
            // let payMethod = this.paymentType.payMethod;
            // const paymentInfo = { ...payment, successUrl: location.origin + '/api/payment/success', failUrl: location.origin + '/api/payment/fail' };
            // if (payMethod === '간편결제') {
            //   payMethod = '02';
            //   paymentInfo.flowMode = 'DIRECT';
            //   paymentInfo.easyPay = this.paymentType.easyPay;
            // }
            // this.tossPayments.requestPayment(payMethod, paymentInfo);
          } else {
            this.saveOrder();
          }
        }
      } catch (e) {
        alert('오류가 발생하였습니다.');
      }
    },
    async saveOrder(mode) {
      if (!this.dupleRequest) {
        this.dupleRequest = true;
        try {
          const result = await postOrder({ bookingList: this.bookingList, groupPersDiv: this.groupPersDiv, cmpl: mode || '' });
          if (result.data?.success) {
            const bundleRvNo = result.data.response.bundleRvNo;
            this.removeCartItem(this.groupPersDiv);
            this.$router.push('/' + this.currentRouteType + '/paymentCmpl/' + bundleRvNo);
          }
        } catch (e) {
          alert('오류가 발생하였습니다.');
          this.dupleRequest = false;
        }
      }
    },
    async onMoreItem() {
      // const firstBookingList = this.bookingList?.[0];
      // let url = '/' + this.currentRouteType;
      // let expDiv = '';

      // if (firstBookingList) {
      //   for (let key in EXP_DIV_CODE) {
      //     if (EXP_DIV_CODE[key] === firstBookingList.pdDiv) {
      //       expDiv = key;
      //     }
      //   }
      // }
      // if (expDiv) {
      //   url = url + '/' + expDiv + '/' + firstBookingList.mrktnPdNo + '/reserve';
      // }
      for (let i = 0; i < this.bookingList.length; i++) {
        await this.addCartItem({ cartItem: this.bookingList[i], replace: true });
      }

      customConfirm('예약 대상 상품이 체험바구니에 담겼습니다. 추가예약을 진행하시겠습니까?', (confirm) => {
        if (confirm) {
          this.$router.push('/grp');
          resolve(true);
        } else {
          this.$router.push('/grp/cart');
          resolve(false);
        }
      });
    },
    /** 확약서 결제 */
    async pledgePayment() {
      await this.saveOrder(this.mode);
    },
    async onPaymentClick() {
      let multiDiscountIndex = 0;
      // 다중할인 확인
      const multiDiscountChk = this.bookingList.some((x, i) => {
        multiDiscountIndex = i;
        return x.multiDiscountYn === 'N';
      });

      if (this.multiDiscountNotice && multiDiscountChk) {
        // 다중할인 적용 문구 가져오기
        //const sameExprText = document.querySelector('.sameExpr').firstChild.textContent;
        this.multiDiscountNotice = false;
        // 선택안한 첫번째로 스크롤 이동
        document.querySelector('.basketList').childNodes[multiDiscountIndex].scrollIntoView(true);
        //alert(`'${sameExprText}'를\r\n선택하면 입장료 할인이 적용됩니다.`);
        this.openModal();
        return false;
      }

      if (!this.reserveInfoAgree) {
        alert('예약안내 및 유의사항에 동의하여야 합니다.');
        return false;
      }
      if (!this.reservePolicyAgree) {
        alert('한국잡월드 이용약관에 동의하여야 합니다.');
        return false;
      }

      const bValid = await orderValid(this.bookingList, '잔여좌석을 확인해주십시요.');
      if (bValid) {
        if (this.mode === 'normal') {
          this.normalPayment();
        } else {
          const pValid = await orderPledge(this.bookingList);
          if (pValid) this.pledgePayment();
        }
      }
    },
    paymentSuccess(bundleRvNo) {
      this.removeCartItem(this.groupPersDiv);
      this.$router.push('/' + this.currentRouteType + '/paymentCmpl/' + bundleRvNo);
    },
    onEasyPayClick(easyPay) {
      this.paymentType.payMethod = '간편결제';
      this.paymentType.easyPay = easyPay;
    },
    checkEasyPaySelected(type) {
      return this.paymentType.payMethod === '간편결제' && this.paymentType.easyPay === type;
    },
    showPcnt(includeList) {
      const grouped = groupBy(includeList, 'groupKey');
      return Object.values(grouped).reduce((a, e) => e[0].pcnt + a, 0);
    },
    onPurmeeBalanceClick() {
      if (!this.purmee.purmeeId) {
        alert('체험카드 아이디를 입력해주세요');
        return false;
      }

      if (!this.purmee.purmeeCardNo) {
        alert('체험카드번호를 입력해주세요');
        return false;
      }

      if (!this.reserveInfoAgree) {
        alert('예약안내 및 유의사항에 동의하여야 합니다.');
        return false;
      }

      if (!this.reservePolicyAgree) {
        alert('한국잡월드 이용약관에 동의하여야 합니다.');
        return false;
      }

      var date = new Date();
      var yyyy = date.getFullYear();
      var mm = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      var trxId = 'koreajobworld_' + this.purmee.purmeeId + '_' + yyyy + mm + dd + hh + min;

      if (typeof window.event_msg !== 'function') {
        const totSaleAmt = this.totSaleAmt;
        window.event_msg = (data) => {
          //alert(JSON.stringify(data));
          //alert(data.balanceResult.code);
          //alert("사용자:"+data.balanceResult.unitName+"\r\n"+"사용가능잔액:"+data.balanceResult.balance);
          //alert("${totSalePrice}");
          if (data.result.code == '00') {
            if (data.balanceResult.balance < totSaleAmt) {
              alert('잔액이 부족합니다.');
              return;
            } else {
              alert('현재 잔액은' + data.balanceResult.balance + '입니다\r\n' + '결제하기 버튼을 클릭하여 진행해주시기 바랍니다.');
              this.setPurmeeBalance(data.balanceResult.balance);
              this.onPurmeePaymentOpen();
            }
          } else {
            alert(data.result.advancedMessage);
          }
        };
      }

      PAYMENT.balance({
        payKey: 'pk_a473-14721f-d30-4aeea',
        trackId: trxId,
        userId: this.purmee.purmeeId,
        card: this.purmee.purmeeCardNo,
        description: '설명',
        eventFnc: 'event_msg',
        udf1: 'udf1',
        udf2: 'udf2',
        udf3: 'udf3',
        udf4: 'udf4',
        debug: true,
      });
    },
    onPurmeePaymentOpen() {
      // 거래 번호
      var date = new Date();
      var yyyy = date.getFullYear();
      var mm = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      var trxId = 'koreajobworld_' + this.purmee.purmeeId + '_' + yyyy + mm + dd + hh + min;

      if (typeof window.event_msg2 !== 'function') {
        var doubleSubmitFlag = false;
        window.event_msg2 = (data) => {
          //alert(JSON.stringify(data));
          if (data.result.code == '00') {
            if (doubleSubmitFlag) {
              return false;
            } else {
              doubleSubmitFlag = true;
              this.saveOrderPurmee(data);
              return false;
            }
          } else {
            alert('결제에 실패했습니다. 다시 시도해주시기 바랍니다.');
          }
        };
      }

      PAYMENT.init({
        payKey: 'pk_a473-14721f-d30-4aeea', // 테스트가맹점 결제키
        trackId: trxId,
        amount: this.totSaleAmt,
        products: '[{"name": "한국잡월드청소년체험관", "price": "' + this.totSaleAmt + '", "qty": 1, "desc": "한국잡월드청소년체험관"}]',
        description: '설명',
        udf1: 'udf1',
        udf2: 'udf2',
        udf3: 'udf3',
        udf4: 'udf4',
        webhookUrl: '',
        redirectUrl: '',
        eventFnc: 'event_msg2',
        widgetPayButton: '결제',
        widgetTheme: 'green',
      });
      PAYMENT.open();
    },
    setPurmeeBalance(balance) {
      this.purmee.purmeeBalance = balance;
    },
    async saveOrderPurmee(data) {
      const prumiParam = JSON.stringify(data);
      const result = await postOrderPrumee({ bookingList: this.bookingList, groupPersDiv: this.groupPersDiv, prumiParam: prumiParam });
      if (result.data?.success) {
        const bundleRvNo = result.data.response.bundleRvNo;
        this.removeCartItem(this.groupPersDiv);
        this.$router.push('/' + this.currentRouteType + '/paymentCmpl/' + bundleRvNo);
      }
    },
    onRefershClick() {
      location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.basketList {
  & > li {
    & > dl {
      & > dd {
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        display: flex;
        justify-content: space-between;

        & .product_price {
          text-align: center;
          & span {
            text-decoration: line-through;
          }
          & strong {
            font-size: 22px;
          }
        }
      }
    }
  }
}
.multiDiscount_box {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.multiDiscount_detail {
  cursor: pointer;
}
.multiDiscount_table {
  min-width: unset;
}

@media only screen and (max-width: 768px) {
  .basketList {
    & > li {
      & > dl {
        & > dd {
          & .product_price {
            & strong {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
  .multiDiscount_box .sameExpr i {
    display: none;
  }
}
.pwEasy_list a.selected {
  border-color: #0087e7;
}

.prumee-input {
  display: flex;
  flex-wrap: wrap;
  .p-label {
    display: inline-block;
    width: 100px;
    padding: 0 5px;
  }
  & input {
    width: 190px;
  }
  & button {
    margin: 0;
    padding: 0.5rem 1rem;
    font-weight: 400;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    width: auto;
    border: none;
    height: 40px;
    border-radius: 4px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    cursor: pointer;
    transition: 0.3s;
    background: #006dbb;
    color: #fff;
    &:active,
    &:hover,
    &:focus {
      background: #025ce2;
      outline: 0;
    }
    &:disabled {
      opacity: 0.5;
    }
  }
}

.ios-msg {
  margin-top: 10px;
  & .strong {
    font-weight: bold;
  }
}
</style>
